import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AssetsUrlPipe } from '@core/pipes';

@Component({
    selector: 'social-header',
    standalone: true,
    templateUrl: './social-header.component.html',
    styleUrl: './social-header.component.scss',
    imports: [
        CommonModule,
        MatToolbarModule,
        AssetsUrlPipe
    ],
})
export class SocialHeaderComponent {}
